import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Aprender tipos de perfiles',
  desc: 'Conoce el catálogo completo y sus usos específicos.'
}, {
  title: 'Elegir materiales correctamente',
  desc: 'Selecciona el perfil ideal para cada necesidad.'
}, {
  title: 'Diseñar estructuras',
  desc: 'Crea planos y despieces precisos.'
}, {
  title: 'Construir proyectos reales',
  desc: 'Ensambla puertas, ventanas y cerramientos.'
}, {
  title: 'Crear presupuestos profesionales',
  desc: 'Calcula costos y márgenes de ganancia.'
}, {
  title: 'Desarrollar proyectos avanzados',
  desc: 'Escala a estructuras complejas y premium.'
}];
export function Learn() {
  return <section className="py-24 relative" data-id="element-147">
      <div className="container mx-auto px-6" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-150">
            Lo que aprenderás
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto relative" data-id="element-151">
          {/* Connecting Line */}
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#2F80ED] via-[#2F80ED]/50 to-transparent md:-translate-x-1/2" data-id="element-152" />

          <div className="space-y-12" data-id="element-153">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: 0.2
          }} className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-154">
                {/* Node */}
                <div className="absolute left-0 md:left-1/2 w-14 h-14 rounded-full bg-[#0D1117] border-2 border-[#2F80ED] flex items-center justify-center z-10 md:-translate-x-1/2 shadow-[0_0_20px_rgba(47,128,237,0.4)]" data-id="element-155">
                  <span className="text-[#2F80ED] font-bold text-lg" data-id="element-156">
                    {idx + 1}
                  </span>
                </div>

                {/* Content */}
                <div className={`ml-20 md:ml-0 md:w-1/2 ${idx % 2 === 0 ? 'md:pl-16' : 'md:pr-16 md:text-right'}`} data-id="element-157">
                  <div className="glass-panel p-6 rounded-2xl hover:border-[#2F80ED]/30 transition-colors" data-id="element-158">
                    <div className="text-sm text-[#2F80ED] font-bold mb-2 uppercase tracking-wider" data-id="element-159">
                      Paso {idx + 1}
                    </div>
                    <h3 className="text-xl font-bold font-heading mb-2 text-white" data-id="element-160">
                      {step.title}
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-161">{step.desc}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}